import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {DocumentUtils} from "../../../Utils";
import {Glyphicon} from "../../Common/GlyphIcon";
import {service as SurveyService} from "../../../Services/SurveyService";
import {useCheckAuth} from "../../../Hooks/RouteHooks";
import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {useContextIndependentPage} from "../../../Hooks/ContextBuilderHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";
import {SurveysTable} from "./Table";
import {SurveysTableFilter} from "./TableFilter";


export const SurveysIndexPage = props => {
    useCheckAuth();
    useContextIndependentPage(props);

    const classNames = useClassNames('sb-surveys-index-page');
    const makePageRequest = useMakePageRequest();

    const [surveys, setSurveys] = useState(null);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        makePageRequest(
            () => SurveyService.GetSurveys(),
            (x) => {
                setSurveys(x.result);
            }
        );
    };

    return <Container className={classNames}>
        <div>
            <StreamBankPageHeader
                Title={"Surveys"}
            />
            <Row>
                <Col xs={12} md={6}><h2>Surveys</h2></Col>
                <Col xs={12} md={6}>
                    <Button variant="link" className="float-right h3" onClick={() => DocumentUtils.changePage("/surveys/new")}>
                        <Glyphicon glyph="plus-sign" />Add Survey
                    </Button>
                </Col>
            </Row>
            <div>
                <hr className="special-hr"/>
            </div>
            <Row>
                <Col xs={12}>
                    <SurveysTable
                        FilterComponent={SurveysTableFilter}
                        Data={surveys}
                    />
                </Col>
            </Row>
        </div>
    </Container>;
};


